import { render } from "./TheDemandSelectPayment.vue?vue&type=template&id=0faab0d2"
import script from "./TheDemandSelectPayment.vue?vue&type=script&lang=js"
export * from "./TheDemandSelectPayment.vue?vue&type=script&lang=js"
script.render = render

export default script